import React, { useState } from 'react';
import clsx from 'clsx';
import { func } from 'prop-types';
import { text } from 'polyglot/polyglot';
import Button from 'components/Button/Button';
import ReturnArrow from 'themes/common/svg/return-arrow.svg';

import styles from './ChangeNickname.module.scss';

function ChangeNickname({ onSave }) {
  const [nickname, setNickname] = useState('');

  return (
    <div className={styles.wrapper}>
      <label className={styles.header} htmlFor="nickname">
        {text.t('settings.changeNickname')}
      </label>
      <div className={styles.inputWrapper}>
        <input
          id="nickname"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          type="text"
          className={styles.input}
          placeholder={text.t('settings.changeNicknamePlaceholder')}
        />
        <Button isIcon onClick={() => onSave(nickname)}>
          <ReturnArrow className={clsx(styles.icon, styles.arrow)} />
        </Button>
      </div>
    </div>
  );
}

ChangeNickname.propTypes = {
  onSave: func.isRequired,
};

export default ChangeNickname;
